<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    modal-size="large"
    modal-alignment="top"
    @submit="submit"
    @close-modal="closeModal"
  >

    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        data-url="/treasury/deposits"
      >

        <div class="form-group row align-items-center">
          <label class="col-sm-3 mb-0">Es Convenio</label>
          <app-input
            class="col-sm-9"
            type="radio-buttons"
            v-model="inputs.is_agreement"
            :list="confirm"
          />
        </div>

        <div class="form-group row align-items-center" v-if="!inputs.is_agreement">
          <label for="inputs_name" class="col-sm-3 mb-0">
            Banco
          </label>
          <app-input
            id="inpbank_id"
            class="col-sm-9"
            type="select"
            v-on:change="handleBlur"
            v-model="inputs.bank_id"
            :list="bankList"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center" v-if="!inputs.is_agreement">
          <label for="inputs_name" class="col-sm-3 mb-0">
            Tipo de transacción
          </label>
          <app-input
            id="inpbank_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.transaction_type_id"
            :list="transactionTypeList"
            :required="true"
          />
        </div>

        <div class="mb-primary" v-if="!inputs.is_agreement">
            <app-note class="pt-2 clearfix" title="Nota" content-type="html" note-type="note-warning"
              :notes="[$t('SE ACEPTARAN ÚNICAMENTE PAGOS EN EFECTIVO (INCLUYE USO DE CHEQUES CERTIFICADOS O DE GERENCIA) Y CON TRANSFERENCIA. EL PAGO DEBE REALIZARSE POR EL VALOR TOTAL Y EXACTO DEL COMPROBANTE.')]" />
        </div>

        <div class="form-group row align-items-center" v-if="!inputs.is_agreement">
          <label for="inputs_name" class="col-sm-3 mb-0">
            Número de transacción
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            @blur="handleBlur"
            v-model="inputs.number"
            :required="true"
          />
          <span class="text-danger" v-if="msgNumber"> {{ msgNumber }}</span>
        </div>

        <div class="form-group row align-items-center" v-if="!inputs.is_agreement">
          <label for="inputs_name" class="col-sm-3 mb-0">
            Valor
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="number"
            v-model="inputs.amount"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center" v-if="!inputs.is_agreement">
          <label for="inputs_name" class="col-sm-3 mb-0">
            Fecha
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="date"
            v-model="inputs.date"
            :required="true"
          />
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
                <h5 class="card-title m-0">
                  {{ inputs.is_agreement ? "Convenio" : "Comprobante de Pago" }}
                </h5>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <app-input type="file"
                      :label="depositFile"
                      v-model="inputs.attach_deposit"
                      v-on:change="fileChoosen"
                      :required="true"/>
              <br>
              <small class="form-text text-muted">Archivo .pdf MAX 4MB</small>
          </div>
          </div>
        </div>

        <div class="form-group row align-items-center" v-if="!inputs.is_agreement && showAnnexes">
          <label class="col-sm-4 mb-0">Requiere Pago de Honorarios para personal externo?</label>
          <app-input class="col-sm-8" type="radio-buttons" v-model="inputs.is_additonal_documentation" :list="fee" />
        </div>

        <div class="row" v-if="inputs.is_additonal_documentation">
          <div class="col-12">
            <div class="form-group">
              <app-note class="pt-2 clearfix" title="Información anexos de Pago de Honorarios para personal externo" content-type="html" note-type="note-warning"
                :notes="[$t('ADJUNTE EN UN ARCHIVO .ZIP TODOS LOS DOCUMENTOS REFERENTES A PAGOS DE HONORARIOS DEL PERSONAL EXTERNO')]" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
                <app-input type="file" :label="feeFile" v-model="inputs.attach_fee" v-on:change="fileChoosenFee"
                  :required="true" />
                <br>
                <small class="form-text text-muted">Archivo .zip MAX 8MB</small>
            </div>
          </div>
        </div>

      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>

  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../../apiUrl";

export default {
    name: "CorrectionModal",
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: String,
        bankList: Array,
        transactionTypeList: Array,
        depositId: Number
    },
    data() {
        return {
          preloader: false,
          showAnnexes: false,
          inputs: {
            is_agreement: 0,
            date: new Date()
          },
          msgNumber: '',
          depositFile: "Seleccionar Archivo",
          feeFile: "Seleccionar Archivo",
          modalId: "correction-add-edit-modal",
          modalTitle: this.$t("add"),
          fee: [{
              id: 0,
              value: "NO",
            },
            {
              id: 1,
              value: "SI",
            },
          ],
          confirm: [
            {
              id: 0,
              value: "NO",
            },
            {
              id: 1,
              value: "SI",
            },
          ],
        };
    },
    created() {
        this.modalTitle = this.$t("Verificación de comprobante de pago");
        this.getInfo();
    },
    methods: {
        getInfo(){
          this.preloader = true;
          let url = `${actions.TREASURY}/${this.depositId}`;
          this.axiosGet(url)
            .then((response) => {
              if (response.status == 200) {
                if(response.data.type === 'P'){
                  this.showAnnexes = true;
                }
              }
            })
            .catch(({ error }) => {
              console.log(error);
            })
            .finally(() => {
              this.preloader = false;
            });
        },
        handleBlur(e) {
          if(this.inputs.number && this.inputs.bank_id){
            this.preloader = true;
            let number = this.inputs.number;
            let url = `${actions.TREASURY}/validateDeposit/${this.inputs.number}/${this.inputs.bank_id}`;
            this.axiosGet(url)
                .then((response) => {
                  if (response.status == 200) {
                    if(!response.data.validate){
                      this.inputs.number = null;
                      this.msgNumber = 'Comprobante '+number+' ya esta registrado';
                    }else{
                      this.msgNumber = '';
                    }
                  }
                })
                .catch(({ error }) => {
                    console.log(error);
                })
                .finally(() => {
                    this.preloader = false;
                });
          }
        },
        fileChoosen(event){
            if(event.target.files[0].type === 'application/pdf'){
                if (event.target.files[0].size < 4111775) {
                    this.depositFile = event.target.files[0].name;
                } else {
                    this.$toastr.e('EL archivo PDF no debe exceder los 2MB.');
                }
            }else{
                this.$toastr.e('Solo permitidos archivos .pdf');
            }
        },
        fileChoosenFee(event) {
            if (event.target.files[0].size < 8111775) {
              this.feeFile = event.target.files[0].name;
            } else {
              this.$toastr.e("El archivo no debe exceder los 8MB.");
            }
        },
        submit() {
          this.inputs.id = this.depositId;
          const tmp = { ...this.inputs};
          if(tmp.date){
            const d = tmp.date;
            tmp.date = [
              d.getFullYear(),
              d.getMonth() + 1,
              d.getDate(),
            ].join("-");
          }
          let formData = new FormData;
          for (const [key, value] of Object.entries(tmp)) {
              formData.append(key, value);
          }
          this.save(formData);
        },
        afterSuccess(response) {
          if (response.status == 200) {
              this.$toastr.s('Su solicitud ha sido enviada a revisión.');
          }
          this.$hub.$emit("reload-" + this.tableId);
        },
        afterSuccessFromGetEditData(response) {
          this.preloader = false;
        },
    },
};
</script>